import styled from 'styled-components';

const RelatedBlogItemStyle = styled.div`
	--rpbInfoPadding: var(--sp4x);
	--rpbTitleMarginBottom: var(--sp3x);
	--rpbSubtitleMarginBottom: var(--sp6x);
	--rbpTagMargin: var(--sp1x);
	--gapTag: var(--sp1x);

	&.rbp-item-cont {
		margin-bottom: calc(2 * var(--colPadding));

		.rbp-item {
			display: flex;
			flex-direction: column;
			height: 100%;
			border-radius: var(--sp2x);
			overflow: hidden;

			.imageCont {
				--imagePaddingTop: 63%;
			}

			.rbp-item-info-cont {
				display: flex;
				flex-direction: column;
				flex: 1;
				padding: var(--rpbInfoPadding);

				.rbp-item-title {
					margin-bottom: var(--rpbTitleMarginBottom);
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.rbp-item-subtitle {
					margin-bottom: var(--rpbSubtitleMarginBottom);
					overflow: hidden;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.rbp-item-tags-cont {
					margin: 0 calc(-1 * var(--rbpTagMargin));
					margin-top: auto;
					display: flex;
					flex-wrap: wrap;
					row-gap: var(--gapTag);

					.rbp-item-tag {
						display: inline-block;
						margin: 0 var(--rbpTagMargin);
					}
				}
			}
		}

		@media (hover: hover) {
			&:hover {
				.rbp-item {
					img {
						transform: scale(1.3);
					}
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--rpbInfoPadding: var(--sp3x);
		--rpbTitleMarginBottom: var(--sp2x);
		--rpbSubtitleMarginBottom: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1-5x);
		--rpbSubtitleMarginBottom: var(--sp4x);
		--gapTag: var(--sp0-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1-5x);
		--rpbSubtitleMarginBottom: var(--sp4x);
		--gapTag: var(--sp0-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1-5x);
		--rpbSubtitleMarginBottom: var(--sp3x);
		--gapTag: var(--sp0-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1x);
		--rpbSubtitleMarginBottom: var(--sp3x);
		--gapTag: var(--sp0-5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1x);
		--rpbSubtitleMarginBottom: var(--sp3x);
		--gapTag: var(--sp0-5x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--rpbInfoPadding: var(--sp2x);
		--rpbTitleMarginBottom: var(--sp1x);
		--rpbSubtitleMarginBottom: var(--sp3x);
		--gapTag: var(--sp0-5x);
	}
`;

export default RelatedBlogItemStyle;
